import { stringToFeetInchesArray } from './stringToFeetInchesArray'

export const formHeightToServerHeight = (heightVal?: string | null) => {
  const feetInches = stringToFeetInchesArray(heightVal)!
  const heightInInchesInt = parseInt(feetInches[0] as any as string) * 12 + parseInt(feetInches[1] as any as string)
  return heightInInchesInt
}
